import React from 'react';
import ImportWizardPage from './ImportWizardPage';
import MapCapitalNeedMandatoryFieldsStep from '../components/capitalNeed/MapCapitalNeedMandatoryFieldsStep';
import MapCapitalNeedAdditionalFieldsStep from '../components/capitalNeed/MapCapitalNeedAdditionalFieldsStep';
import CapitalNeedPreviewStep from '../components/capitalNeed/PreviewStep';
import CapitalNeedSubmitModal from '../components/capitalNeed/SubmitModal';
import CapitalNeedSuccessModal from '../components/capitalNeed/SuccessModal';

const initialTargetDropdownSelections: Record<string, string> = {
  asset_identifier: 'asset_tag',
};

const NewDataCapitalNeedImportPage: React.FC = () => (
  <ImportWizardPage
    title="New Data Capital Need Import"
    entityLabelPlural="capital needs"
    listPath="/assets/list"
    initialTargetDropdownSelections={initialTargetDropdownSelections}
    uniqueFieldKey="asset_identifier"
    MapMandatoryFieldsStep={MapCapitalNeedMandatoryFieldsStep}
    MapAdditionalFieldsStep={MapCapitalNeedAdditionalFieldsStep}
    PreviewStep={CapitalNeedPreviewStep}
    SubmitModal={CapitalNeedSubmitModal}
    SuccessModal={CapitalNeedSuccessModal}
  />
);

export default React.memo(NewDataCapitalNeedImportPage);
